import { useEffect, useState } from "react";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FALLBACK_REVIEWS = [
  { id: "r1", author: "Aman Kumar", rating: 5, text: "The Chappan Bhog is unreal. Kids loved it.", relative_time: "2 weeks ago" },
  { id: "r2", author: "Priya Sahu", rating: 5, text: "Family packs were fresh and delivery was on time.", relative_time: "a month ago" },
  { id: "r3", author: "Rahul Verma", rating: 5, text: "Pista Kulfi tastes amazing. Best late-night stop.", relative_time: "3 weeks ago" },
];

export default function ReviewsCarousel() {
  const [reviews, setReviews] = useState(FALLBACK_REVIEWS);

  useEffect(() => {
    axios.get(`${API}/reviews`)
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : FALLBACK_REVIEWS;
        setReviews(list);
      })
      .catch(() => {
        setReviews(FALLBACK_REVIEWS);
      });
  }, []);

  const tints = ["bg-ice-pink", "bg-mint", "bg-sun-yellow-soft"];

  return (
    <section className="relative py-20 md:py-28" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-holiday-red font-bold">Loved by Gorakhpur</p>
            <h2 className="font-display text-4xl md:text-5xl mt-2">4.9 stars. 31 reviews. Counting.</h2>
          </div>
          <div className="flex items-center gap-1.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-sun-yellow text-sun-yellow"/>
            ))}
          </div>
        </div>

        <div className="flex gap-5 overflow-x-auto no-scrollbar -mx-4 px-4 snap-x snap-mandatory" data-testid="reviews-carousel">
          {reviews.map((r, i) => (
            <article
              key={r.id}
              data-testid={`review-card-${r.id}`}
              className={`shrink-0 snap-start w-[85%] sm:w-[420px] ${tints[i % 3]} rounded-[2rem] p-7 cushion border border-[#F0E4E4]`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-holiday-red text-holiday-red"/>
                ))}
              </div>
              <p className="font-serif text-lg leading-relaxed text-choc">"{r.text}"</p>
              <div className="mt-5 flex items-center justify-between text-xs">
                <span className="font-bold uppercase tracking-widest">{r.author}</span>
                <span className="text-choc/60">{r.relative_time}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

